import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import LoadingSpinner from "./LoadingSpinner";

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

/**
 * 인증이 필요한 페이지를 보호하는 컴포넌트
 * 로그인하지 않은 사용자는 지정된 경로로 리다이렉트
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectTo = "/auth",
}) => {
  const { isLoggedIn, isInitialized } = useAuth();

  // 인증 상태 초기화 중이면 로딩 화면 표시
  if (!isInitialized) {
    return (
      <div className="h-screen-dvh bg-gray-50 flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  // 로그인하지 않은 경우 지정된 경로로 리다이렉트
  if (!isLoggedIn) {
    return <Navigate to={redirectTo} replace />;
  }

  // 로그인한 사용자에게는 자식 컴포넌트 렌더링
  return <>{children}</>;
};

export default ProtectedRoute;
